import { Epic } from 'redux-observable';
import { filter, ignoreElements, tap, withLatestFrom } from 'rxjs';
import { isOfType } from 'typesafe-actions';
import { ActionType, ActionTypes } from '../actionTypes';
import { RootState } from '../types';
import { clearState, persistState, StorageTypes } from '../../utils/persistentState';

const storeTempUserEpic: Epic<ActionTypes, ActionTypes, RootState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType([ActionType.SET_TEMP_USER])),
    withLatestFrom(state$),
    tap(([action]) => {
      const tempUser = action.payload;
      if (tempUser) {
        persistState(tempUser, StorageTypes.TemporaryUser);
      } else {
        clearState(StorageTypes.TemporaryUser);
      }
    }),
    // Return EMPTY to ensure no actions are dispatched
    ignoreElements()
  );

export default storeTempUserEpic;
